import React, {useMemo} from 'react';
import {RecommendationSourceObjectType} from '@udemy-v2/react-recommendations';
import {
    LimitedAccessRecommendationsSourceObject,
    LimitedAccessRecommendationsWrapper,
} from './limited-access-recommendations-wrapper.react-component';
import {LimitedAccessRecommendationsCarousel} from './limited-access-recommendations-carousel.react-component';

export interface UnavailableCourseCategoryProps {
    categoryId?: string;
    subcategoryId?: string;
}

interface UnavailableCourseCategoryRecommendationsWrapperProps
    extends UnavailableCourseCategoryProps {
    children: React.ReactNode;
}

const useCategorySourceObjects = (
    categoryId?: string,
    subcategoryId?: string,
): LimitedAccessRecommendationsSourceObject[] =>
    useMemo(() => {
        const sourceObjects: LimitedAccessRecommendationsSourceObject[] = [];
        if (subcategoryId) {
            sourceObjects.push({
                id: subcategoryId,
                type: RecommendationSourceObjectType.Subcategory,
            });
        }
        if (categoryId) {
            sourceObjects.push({
                id: categoryId,
                type: RecommendationSourceObjectType.Category,
            });
        }
        return sourceObjects;
    }, [categoryId, subcategoryId]);

export const UnavailableCourseCategoryRecommendationsWrapper = ({
    categoryId,
    subcategoryId,
    children,
}: UnavailableCourseCategoryRecommendationsWrapperProps) => {
    const sourceObjects = useCategorySourceObjects(categoryId, subcategoryId);

    return (
        <LimitedAccessRecommendationsWrapper
            sourceObjects={sourceObjects}
            contextId="disabled_course_category"
        >
            {children}
        </LimitedAccessRecommendationsWrapper>
    );
};

export const UnavailableCourseCategoryCarousel = ({
    categoryId,
    subcategoryId,
}: UnavailableCourseCategoryProps) => (
    <UnavailableCourseCategoryRecommendationsWrapper
        categoryId={categoryId}
        subcategoryId={subcategoryId}
    >
        <LimitedAccessRecommendationsCarousel />
    </UnavailableCourseCategoryRecommendationsWrapper>
);
